import { Card, CardContent, CircularProgress, Icon, Typography } from '@material-ui/core';
import { Formik } from 'formik';

// local imports
import { useCustomerOrdersService, useQuery } from 'app/hooks/services';
import { CustomDataTable } from 'app/components/organisms/table';
import { CustomCard } from 'app/components/atoms';
import { FilterCustomerOrders } from 'app/components/organisms/filter-forms';
import { EnvDefaults } from 'app/utils';

const tableQueries = {
  skip: 0,
  limit: 25,
  orderBy: 'created_at',
  sortBy: 'desc',
  min_order_date: '',
  max_order_date: '',
  order_statuses: '',
  pharmacy_name: '',
  order_no: ''
};

const CustomerOrders = ({ customerId }) => {
  // service connection
  const { queries, handleFilterChange, handlePageChange, handleSort, isFilteringRef } =
    useQuery(tableQueries);
  const { service, handleRefresh } = useCustomerOrdersService(queries, customerId, isFilteringRef);

  return (
    <>
      <CustomCard icon="bx-file" title="Müşteri Siparişleri" contentClassName="px-20">
        {/* Filter form */}
        <Card className="mb-16" elevation={4}>
          <CardContent>
            <div className="flex items-center">
              <Icon>filter_list</Icon>
              <Typography variant="subtitle1" className="text-gray-700 font-semibold mx-8">
                Filtrele
              </Typography>
              {isFilteringRef.current && (
                <CircularProgress color="secondary" size={22} thickness={6} />
              )}
            </div>

            <Formik initialValues={EnvDefaults.filterCustomersOrders}>
              <FilterCustomerOrders handleChange={handleFilterChange} />
            </Formik>
          </CardContent>
        </Card>

        <CustomDataTable
          keyField="order_no"
          defaultSortId={queries?.orderBy}
          defaultDirection={queries?.sortBy}
          service={service}
          queries={queries}
          handlePageChange={handlePageChange}
          handleChange={handleFilterChange}
          handleSort={handleSort}
          handleRefreshTable={handleRefresh}
        />
      </CustomCard>
    </>
  );
};

export default CustomerOrders;
